import { render, staticRenderFns } from "./customerInformationUpdate.vue?vue&type=template&id=51687996&scoped=true"
import script from "./customerInformationUpdate.vue?vue&type=script&lang=js"
export * from "./customerInformationUpdate.vue?vue&type=script&lang=js"
import style0 from "./customerInformationUpdate.vue?vue&type=style&index=0&id=51687996&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51687996",
  null
  
)

export default component.exports